var _rect, _rect2, _rect3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStoreWithPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 152,
    viewBox: "0 0 134 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -3.78125,
    y: -23.002,
    width: 148.78,
    height: 215.83,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -3.78125,
    y: -23.002,
    width: 148.78,
    height: 216.227,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7485_96790",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: -24,
    width: 149,
    height: 218
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -3.78125,
    y: -23.002,
    width: 148.78,
    height: 216.227,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7485_96790)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.78125,
    y: 101.18,
    width: 148.78,
    height: 43.6421,
    fill: "#BABBBE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.78125,
    y: 101.18,
    width: 148.78,
    height: 6.34794,
    fill: "#002042"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.168 107.527H110.504H121.989V144.822H100.168V107.527Z",
    fill: "#828489"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2305 107.527H29.9426H41.845V144.822H19.2305V107.527Z",
    fill: "#828489"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.78125,
    y: 117.843,
    width: 148.78,
    height: 5.95119,
    fill: "#FFC120"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.1641,
    y: 113.81,
    width: 87.2841,
    height: 23.0113,
    fill: "#1A7FE0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.78125,
    y: 136.822,
    width: 148.78,
    height: 48.403,
    fill: "#E3E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1649 136.822H114.449L144.999 165.387V185.225H-3.78125L-3.78125 165.387L27.1649 136.822Z",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.1641,
    y: 111.827,
    width: 87.2841,
    height: 9.12516,
    fill: "#002042"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.78125,
    y: 136.822,
    width: 148.78,
    height: 3.57071,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.3516,
    y: 116.984,
    width: 34.1202,
    height: 19.8373,
    fill: "#8ECBFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.0781,
    y: 123.729,
    width: 17.4568,
    height: 13.0926,
    fill: "#00172C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.3516,
    y: 122.935,
    width: 34.5169,
    height: 1.19024,
    fill: "#002042"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9531,
    y: 116.984,
    width: 34.9137,
    height: 1.19024,
    fill: "#002042"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.9531,
    y: 116.984,
    width: 1.19024,
    height: 19.8373,
    fill: "#002042"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.6758,
    y: 116.984,
    width: 1.19024,
    height: 19.8373,
    fill: "#002042"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.0117,
    y: 116.984,
    width: 1.19024,
    height: 19.8373,
    fill: "#002042"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.6797,
    y: 116.984,
    width: 1.19024,
    height: 19.8373,
    fill: "#002042"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.7422,
    y: 116.984,
    width: 1.19024,
    height: 19.8373,
    fill: "#002042"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.1641,
    y: 111.827,
    width: 87.2841,
    height: 1.98373,
    fill: "#00172C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.8672,
    y: 126.109,
    width: 26.582,
    height: 0.396746,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.8672,
    y: 131.267,
    width: 26.582,
    height: 0.396746,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.1641,
    y: 126.109,
    width: 25.7885,
    height: 0.396746,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.1641,
    y: 131.267,
    width: 25.7885,
    height: 0.396746,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.828 69.0161C116.828 69.0161 90.581 68.5773 68.0405 73.1991C45.5 77.821 23.9895 88.0523 23.9895 88.0523V94.3698L27.957 97.5437V100.321V107.462H23.9895V112.223H116.828V107.462H112.861V90.7991V77.7064H116.828V69.0161Z",
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.9922,
    y: 106.272,
    width: 93.2353,
    height: 5.95119,
    fill: "#FFC120"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1641 112.223H23.9901L27.1641 113.81V112.223Z",
    fill: "#00172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.227 112.223L114.449 112.223V113.81L117.227 112.223Z",
    fill: "#00172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.848 75.3635C114.848 75.3635 89.7222 74.9303 68.145 79.493C46.5678 84.0556 25.9765 94.1559 25.9765 94.1559V106.272H114.848V75.3635Z",
    fill: "#002042"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9922 98.3372L25.9759 97.147V100.718L23.9922 98.3372Z",
    fill: "#00172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.828 79.6901L114.844 79.6901V83.2608L116.828 79.6901Z",
    fill: "#00172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0405 78.3141C90.581 73.7391 116.828 74.1734 116.828 74.1734V79.8335C106.332 80.0137 85.9488 80.8683 67.6781 84.579C50.1701 88.1348 33.2011 94.5977 23.9896 98.4376V93.0167C23.9896 93.0167 45.5001 82.8891 68.0405 78.3141Z",
    fill: "#00172C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1217 95.8388C77.1217 95.9557 77.1108 96.0765 77.0793 96.182C76.948 96.6221 76.4976 96.994 75.9337 96.994C75.4642 96.994 75.0905 96.7241 75.0905 96.154C75.0905 95.2818 76.0405 95.0409 77.1217 95.0466V95.8388ZM78.8172 94.3193C78.8172 92.8809 78.2096 91.6145 76.1557 91.6145C75.1004 91.6145 74.264 91.9142 73.8068 92.1807L74.1416 93.3371C74.5589 93.0711 75.224 92.8511 75.8534 92.8511C76.8954 92.8481 77.0668 93.4471 77.0668 93.8309V93.9215C74.7948 93.9179 73.3594 94.7132 73.3594 96.3329C73.3594 97.3225 74.0908 98.2496 75.3614 98.2496C76.1427 98.2496 76.7966 97.9338 77.1886 97.4287H77.2266C77.2266 97.4287 77.4865 98.526 78.9166 98.1062C78.8408 97.6496 78.8172 97.1627 78.8172 96.5765V94.3193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4297 89.656C43.4297 89.656 44.9132 95.8045 45.1501 96.8022C45.4264 97.9669 45.9249 98.3956 47.3609 98.1061L48.2873 94.2945C48.5227 93.3475 48.6799 92.6727 48.8309 91.7096H48.8572C48.9636 92.6822 49.1146 93.3507 49.3078 94.2978C49.3078 94.2978 49.6848 96.0278 49.8782 96.9369C50.072 97.8455 50.6109 98.418 52.0174 98.1061L54.2259 89.656H52.443L51.6892 93.3093C51.4862 94.3726 51.3022 95.2042 51.1606 96.1769H51.1353C51.0067 95.2135 50.8424 94.4155 50.6362 93.3794L49.8517 89.656H47.9948L47.1545 93.2857C46.9173 94.3887 46.6941 95.2788 46.5531 96.2189H46.5274C46.3823 95.3339 46.1891 94.2146 45.9803 93.1471C45.9803 93.1471 45.4819 90.5508 45.3067 89.656H43.4297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5974 95.8388C57.5974 95.9557 57.5874 96.0765 57.5552 96.182C57.4237 96.6221 56.973 96.994 56.4103 96.994C55.9402 96.994 55.5671 96.7241 55.5671 96.154C55.5671 95.2818 56.5168 95.0409 57.5974 95.0466V95.8388ZM59.2926 94.3193C59.2926 92.8809 58.685 91.6145 56.632 91.6145C55.5767 91.6145 54.7396 91.9142 54.2831 92.1807L54.6169 93.3371C55.0346 93.0711 55.6997 92.8511 56.3296 92.8511C57.372 92.8481 57.5424 93.4471 57.5424 93.8309V93.9215C55.2711 93.9179 53.8359 94.7132 53.8359 96.3329C53.8359 97.3225 54.5662 98.2496 55.8362 98.2496C56.6184 98.2496 57.272 97.9338 57.6642 97.4287H57.7029C57.7029 97.4287 57.9618 98.526 59.392 98.1062C59.3174 97.6496 59.2926 97.1627 59.2926 96.5765V94.3193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1234 96.3123V89.656H60.4258V98.1061H62.1234V96.3123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.3281 89.656V95.89C84.3281 96.7497 84.488 97.3517 84.8304 97.7194C85.1292 98.0414 85.622 98.2495 86.2119 98.2495C86.7136 98.2495 87.2076 98.1532 87.4406 98.0656L87.4191 96.7243C87.2454 96.7673 87.0463 96.8022 86.7741 96.8022C86.1957 96.8022 86.0022 96.4274 86.0022 95.656V93.2711H87.4804V91.6544H86.0022V89.656H84.3281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9492 91.7582V98.1062H81.7003V94.856C81.7003 94.6804 81.7103 94.5277 81.7377 94.3873C81.8672 93.7065 82.3828 93.2712 83.1222 93.2712C83.3245 93.2712 83.4705 93.293 83.6274 93.3165V91.6542C83.4959 91.6276 83.405 91.6145 83.2413 91.6145C82.588 91.6145 81.8448 92.0412 81.5327 92.956H81.485V91.7582H79.9492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3086 91.7582V98.1062H65.0151V94.3831C65.0151 94.209 65.0355 94.0244 65.0956 93.8637C65.2363 93.4892 65.5811 93.0508 66.132 93.0508C66.8207 93.0508 67.1428 93.6388 67.1428 94.4884V98.1062H68.8467V94.3384C68.8467 94.1717 68.8697 93.971 68.9186 93.8237C69.0584 93.3976 69.4303 93.0508 69.9421 93.0508C70.6405 93.0508 70.9752 93.6287 70.9752 94.6279V98.1062H72.6803V94.3673C72.6803 92.3957 71.6908 91.6145 70.5729 91.6145C70.0771 91.6145 69.6866 91.7403 69.3336 91.9595C69.0369 92.1441 68.7709 92.4053 68.5382 92.7503H68.5128C68.2429 92.0665 67.6088 91.6145 66.7827 91.6145C65.7212 91.6145 65.2434 92.159 64.9538 92.6209H64.9284V91.7582H63.3086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0653 96.6785C97.0291 96.4486 96.7536 96.2694 96.4121 96.2694C96.0746 96.2694 95.7965 96.4477 95.7582 96.6761L95.4258 100.489C95.4258 100.866 95.862 101.177 96.4109 101.177C96.9645 101.177 97.4001 100.866 97.4001 100.489L97.0653 96.6785Z",
    fill: "#FFC120"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.3555 95.8415C94.5345 95.6954 94.5496 95.3638 94.3785 95.0647C94.2098 94.7692 93.9193 94.6151 93.704 94.6962L90.2706 96.3114C89.9482 96.4992 89.901 97.0366 90.1756 97.5172C90.4526 98.0018 90.9348 98.2278 91.2581 98.0396L94.3555 95.8415Z",
    fill: "#FFC120"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1361 94.7254C98.9208 94.6428 98.6294 94.7942 98.4592 95.093C98.2905 95.3888 98.3032 95.7216 98.4808 95.8689L101.58 98.0671C101.904 98.2552 102.387 98.028 102.661 97.5476C102.938 97.0622 102.891 96.527 102.568 96.3385L99.1361 94.7254Z",
    fill: "#FFC120"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0963 91.0988C97.0609 91.3287 96.7848 91.5079 96.4433 91.5079C96.1059 91.5079 95.8275 91.3302 95.79 91.1012L95.457 87.2881C95.457 86.9115 95.8932 86.6017 96.4427 86.6017C96.996 86.6017 97.4311 86.9115 97.4311 87.2881L97.0963 91.0988Z",
    fill: "#FFC120"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1516 93.0785C98.9362 93.162 98.6451 93.0108 98.4741 92.7109C98.306 92.4157 98.3195 92.0832 98.4959 91.9356L101.596 89.7377C101.919 89.5496 102.402 89.7765 102.676 90.2572C102.954 90.7417 102.906 91.2775 102.583 91.4663L99.1516 93.0785Z",
    fill: "#FFC120"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.3711 91.9086C94.5499 92.0556 94.5652 92.3866 94.3944 92.6854C94.2254 92.9806 93.934 93.1356 93.7196 93.0539L90.2862 91.4387C89.9639 91.2506 89.9167 90.7141 90.1913 90.2335C90.4685 89.7483 90.951 89.5223 91.2731 89.7105L94.3711 91.9086Z",
    fill: "#FFC120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6055 132.061C46.6055 131.622 46.9607 131.267 47.399 131.267H47.7957C48.2339 131.267 48.5892 131.622 48.5892 132.061V144.36H46.6055V132.061Z",
    fill: "#FFC220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8359 132.061C91.8359 131.622 92.1912 131.267 92.6294 131.267H93.0262C93.4644 131.267 93.8197 131.622 93.8197 132.061V144.36H91.8359V132.061Z",
    fill: "#FFC220"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.605,
    y: 131.729,
    width: 7.14143,
    height: 13.0926,
    fill: "#00172C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.605469,
    y: 123.794,
    width: 19.8373,
    height: 13.0926,
    fill: "#9E9FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2293 33.1376C87.2293 45.2384 70.4877 61.4282 70.4877 61.4282C70.4877 61.4282 53.7461 45.7156 53.7461 33.1376C53.7461 22.4255 61.2416 15.8792 70.4877 15.8792C79.7338 15.8792 87.2293 22.4255 87.2293 33.1376Z",
    fill: "#0071DC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.4888,
    cy: 32.6604,
    rx: 10.1645,
    ry: 10.1886,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7485_96790)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7485_96790)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.876 36.623C68.731 36.623 68.5861 36.5696 68.4728 36.4628L66.4413 34.5432C66.206 34.3204 66.1955 33.9491 66.4185 33.7139C66.6409 33.4788 67.0123 33.4688 67.2476 33.6905L68.8754 35.2289L74.6512 29.7463C74.8853 29.5234 75.2567 29.5322 75.4803 29.768C75.7039 30.0026 75.6939 30.3738 75.4592 30.5967L69.2797 36.4617C69.167 36.569 69.0215 36.623 68.876 36.623Z",
    fill: "#002242"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7485_96790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.1089,
    height: 11.1089,
    fill: "white",
    transform: "translate(65.5742 27.7357)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7485_96790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.7121,
    height: 10.7121,
    fill: "white",
    transform: "translate(65.6719 27.8254)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreWithPin);
export default __webpack_public_path__ + "static/media/storeWithPin.d3c10f7737bbe3f225cb76fe0625a813.svg";
export { ForwardRef as ReactComponent };